import Button from "./Button";
import useBreadcrumbs from "../features/navigation/hooks/useBreadcrums";
import styles from "./breadcrumbs.module.css";

const Breadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs();
  if (breadcrumbs.length < 2) return null;

  return (
    <div className={styles.breadcrumbs}>
      {breadcrumbs?.map((crumb, idx) => {
        const { itemKey, ...rest } = crumb;
        return (
          <div key={itemKey} className={styles.breadcrumb}>
            {idx !== breadcrumbs.length - 1 ? (
              <Button key={itemKey} inline {...rest} />
            ) : (
              <p
                key={itemKey}
                style={{
                  padding: "0 var(--padding-button-h)",
                  fontSize: "var(--font-size-button)",
                  lineHeight: "var(--line-height-button)",
                  fontWeight: "600",
                }}
              >
                {crumb.caption}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
